@if (isCTalkAdmin()) {
    <div class="page-content">
        <router-outlet></router-outlet>
    </div>
} @else {
  <div id="wrapper">
    <my-page-header>
    <my-scalar-close class="closeButton headerButton"></my-scalar-close>
  </my-page-header>
  <div class="page-content client-content">
    <router-outlet></router-outlet>
  </div>
</div>
}

